import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid } from "@mui/material";
import { Form } from "@shared/components";

export function RegisterStep() {
  const translate = useTranslate();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("flux.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="price"
          label={translate("flux.fields.price")}
          mask="number"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="email"
          label={translate("flux.fields.email")}
          type="email"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="cnpj"
          label={translate("flux.fields.cnpj")}
          mask="cnpj"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="website"
          label={translate("flux.fields.website")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="cpf_linking_limit"
          label={translate("flux.fields.cpf_limit")}
          mask="number"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="promo_code_limit"
          label={translate("flux.fields.promo_limit")}
          mask="number"
        />
      </Grid>
    </Grid>
  );
}
